<template>
<form @submit.prevent="submit">
  <div class="form-group" :class="{ 'input-group-sm': small }">
    <label for="input_elem" v-if="caption">{{ caption }}</label>
    <div class="row" v-if="!verifyMode">
        <div class="col">
            <input :disabled="!addingNew"
              type="text" 
              class="form-control" 
              v-model.trim="inputData"
              :class="{ 'is-invalid' : (isError || classError) && !success, 'is-valid': success && !isError }"
              :style="'background-color: ' + bgColor"
              :placeholder="placeholder" 
            /> <!-- input -->
        </div>
        <div class="col-md-2" v-if="!isVerified && shouldBeVerified">
            <button class="btn btn-sm btn-primary" type="button" @click="verifyMode = true">подтвердить</button>
        </div>
        <div class="col-md-2" v-else-if="addingNew">
            <button class="btn btn-sm btn-primary" type="button" @click="sendCurrentValue" :disabled="!isFullNumber">добавить</button>
        </div>
        <div class="col-2 d-flex" v-if="canBeDeleted">
            <button
              type="button"
              class="btn btn-light rounded btn-sm align-self-start"
              @click="$emit('delete')">{{ addingNew ? 'отмена' : 'удалить'}}
            </button>
        </div>
    </div>
    <div v-else class="alert alert-warning">
        <div v-if="sendingCode">
            <p>Отправка проверочного кода на номер {{ formattedValue }}...</p>
        </div>
        <div class="row" v-else>
            <div class="col">
                <p>Введите код, отправленный на номер {{ formattedValue }}</p>
                <div class="form-inline">
                    <div class="form-group" style="padding-right: 10px">
                        <input type="text" :class="{'form-control': true, 'input-lg': true, 'is-invalid': (isError || classError)}" width="5" ref="codeInput" v-model="code" />
                    </div>
                    <button type="button" class="btn btn-primary" :disabled="!validCode" @click="confirmByCode">Подтвердить</button>
                </div>
            </div>
            <div class="col-2">
                <button
                  type="button"
                  class="btn btn-light rounded btn-sm align-self-start"
                  @click="verifyMode = false">отмена
                </button>
            </div>
        </div>
    </div>
    <small class="form-text text-warning" v-if="addingNew && shouldBeVerified && !isVerified && !verifyMode">Телефон нужно подтвердить</small>
    <small class="form-text text-success" v-if="isVerified">✓Телефон подтверждён</small>
    <small class="form-text text-danger" v-if="isError">{{ textError }}</small>
    <small class="form-text text-info" v-else-if="maxLength > 0 && !hideTextLength">{{ inputData.length }} / {{ maxLength }}</small>
  </div>
</form>
</template>

<script>
const justVerifiedHash = {};

export default {
  props: {
    isError: Boolean,
    textError: String,
    caption: String,
    maxLength: Number,
    success: Boolean,
    small: Boolean,
    bgColor: String,
    value: String,
    placeholder: String,
    hideTextLength: Boolean,
    canBeDeleted: {
        type: Boolean,
        default: true
    }
  },
  data() {
      setInterval(() => {
          console.log(justVerifiedHash);
      }, 1000);
    return {
      inputData: this.value,
      classError: false,
      verifyMode: false,
      sendingCode: false,
      checkingCode: false,
      code: '',
      justVerified: false,
    }
  },
  watch: {
    value: function() {
      this.inputData = this.value;
    },
    verifyMode(v) {
        if (v) {
            this.sendingCode = true;
            this.code = '';

            this.$store.dispatch(
                'sendPhoneVerifyCode', this.inputData
            ).catch(() => {
                this.verifyMode = false;
            }).finally(() => {
                this.sendingCode = false;
            });

            setTimeout(() => {
                if (this.$refs.codeInput) {
                    this.$refs.codeInput.focus();
                }
            }, 100);
        }
    }
  },
  computed: {
      shouldBeVerified() {
          return !!this.formattedValue.match(/^\+79\d{9}$/)
      },
      isVerified() {
          return !!this.verifiedPhonesMap[ this.inputData ] || this.justVerified;
      },
      formattedValue() {
          return '+' + (this.inputData || '').replace(/\D/, '').replace(/^8(\d{10})$/, '7$1')
      },
      isFullNumber() {
          return !!this.formattedValue.match(/\d{11}/);
      },
      addingNew() {
          return (this.value === '') && !this.justVerified;
      },
      verifiedPhonesMap() {
          const result = {};
          (this.$store.getters.getUserData?.memberInfo?.phones || []).forEach((item) => {
              result[ item.value ] = item.verified
          });

          Object.keys(justVerifiedHash).forEach(value => {
              result[ value ] = true;
          });

          return result;
      },
      formattedCode() {
          return this.code.replace(/\s*/, '');
      },
      validCode() {
          return !!this.formattedCode.match(/^\d{5}$/);
      }
  },
  methods: {
    sendCurrentValue() {
      this.$emit("on-input", this.inputData)
    },
    confirmByCode() {
        this.checkingCode = true;

        this.$store.dispatch(
            'confirmPhoneByCode', {phone: this.inputData, code: this.code}
        ).then(() => {
            this.verifyMode = false;
            this.justVerified = true;
            justVerifiedHash[ this.inputData ] = true;
            this.sendCurrentValue();
        }).finally(() => {
            this.checkingCode = false;
        });
    },
    tryToSave() {
        if (!this.isVerified && this.shouldBeVerified) {
            if (this.addingNew) {
                this.verifyMode = true;
                return false;
            }

            return true;
        } else if (this.addingNew) {
            this.sendCurrentValue();
            return true;
        }
    },
    submit() {
        if (this.verifyMode && this.validCode) {
            this.confirmByCode();
        } else {
            this.tryToSave();
        }

    }
  }
}
</script>

<style scoped>
  input[type='button'] {
    border: none;
    background-color: white;
  }
  .info {
    color: teal;
  }
</style>
